import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="bm-card bm-empty">
      <h3 className="h-card">Not found</h3>
      <p className="muted" style={{ fontSize: 13 }}>
        The page you requested does not exist.
      </p>
      <Link to="/dashboard" className="bm-btn bm-btn-primary bm-btn-sm">
        Back to dashboard
      </Link>
    </div>
  );
}
